import { Image } from 'antd';
import { useTranslation } from 'react-i18next';
import Logo from '../../../assets/company/logo.png';
import { useNavigate } from 'react-router-dom';

const ForgetPasswordHeader = () => {
  const { t } = useTranslation('signIn');
  const navigate = useNavigate();

  return (
    <>
      <Image preview={false} src={Logo} width={250} onClick={() => navigate('/')} className='cursor-pointer' />
      <h1 className="w-full text-2xl font-bold mb-4 mt-4 text-center p-0 md:px-10">{t('welcomeMessage')}</h1>
      <p className='mb-4 font-medium'>{t('forgetPasswordMessage')}</p>
    </>
  );
};

export default ForgetPasswordHeader;
